import { formatLcp } from './formatLcp';

export const METRIC_HELP = {
  lcp: 'So lange dauert es, bis das größte Inhaltselement auf der Seite gezeichnet ist, zum Beispiel ein Hero-Bild.\n\nEine gute Nutzererfahrung liegt bei 2,5 Sekunden oder weniger.',
  inp: 'So lange dauert es, bis die Seite auf eine Eingabe sichtbar reagiert, etwa auf einen Klick oder Tastendruck.\n\nEine gute Nutzererfahrung liegt bei 200 Millisekunden oder weniger.',
  cls: 'Wie stark sich das Layout der Seite beim Laden verschiebt.\n\nEine gute Nutzererfahrung liegt bei einem Wert von 0,1 oder weniger.',
  ti: 'So lange dauert es, bis die Seite vollständig bedienbar ist.\n\nEine gute Nutzererfahrung liegt bei 2,5 Sekunden oder weniger.',
};

const TEXT_TONE = {
  good: 'text-green-600',
  moderate: 'text-yellow-600',
  poor: 'text-red-600',
  neutral: 'text-gray-400',
};

const BADGE_TONE = {
  good: 'text-green-600 bg-green-50',
  moderate: 'text-yellow-600 bg-yellow-50',
  poor: 'text-red-600 bg-red-50',
  neutral: 'text-gray-500 bg-gray-50',
};

function band(value, good, moderate) {
  if (value <= good) {
    return 'good';
  }

  if (value <= moderate) {
    return 'moderate';
  }

  return 'poor';
}

function finiteNumber(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function formatCls(value) {
  const number = finiteNumber(value);

  if (number === null) {
    return '–';
  }

  return number.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
}

export function formatOptionalDuration(value) {
  const number = finiteNumber(value);

  if (number === null || number <= 0) {
    return '–';
  }

  return formatLcp(number);
}

export function scoreTextClass(score) {
  return score >= 80 ? TEXT_TONE.good : TEXT_TONE.poor;
}

export function scoreBadgeClass(score) {
  return score >= 80 ? BADGE_TONE.good : BADGE_TONE.poor;
}

export function scoreStatus(score) {
  if (score >= 90) {
    return 'Excellent';
  }

  if (score >= 80) {
    return 'Good';
  }

  return 'Needs Improvement';
}

export function durationTextClass(value, good, moderate) {
  const number = finiteNumber(value);

  if (number === null) {
    return TEXT_TONE.neutral;
  }

  return TEXT_TONE[band(number, good, moderate)];
}

export function durationBadgeClass(value, good, moderate) {
  const number = finiteNumber(value);

  if (number === null) {
    return BADGE_TONE.neutral;
  }

  return BADGE_TONE[band(number, good, moderate)];
}

export function durationStatus(value, good, moderate) {
  const number = finiteNumber(value);

  if (number === null) {
    return '';
  }

  const level = band(number, good, moderate);

  if (level === 'good') {
    return 'Fast';
  }

  if (level === 'moderate') {
    return 'Moderate';
  }

  return 'Slow';
}

export function clsTextClass(value) {
  const number = finiteNumber(value);

  if (number === null) {
    return TEXT_TONE.neutral;
  }

  return TEXT_TONE[band(number, 0.1, 0.25)];
}

export function clsBadgeClass(value) {
  const number = finiteNumber(value);

  if (number === null) {
    return BADGE_TONE.neutral;
  }

  return BADGE_TONE[band(number, 0.1, 0.25)];
}

export function clsStatus(value) {
  const number = finiteNumber(value);

  if (number === null) {
    return '';
  }

  const level = band(number, 0.1, 0.25);

  if (level === 'good') {
    return 'Good';
  }

  if (level === 'moderate') {
    return 'Moderate';
  }

  return 'Poor';
}
